import { gsap } from 'gsap'

export const enter = function (el, done) {
  gsap.timeline({
    onComplete: done
  })
    .from(el, {
      y: '100%'
    })
}

export const leave = function (el, done) {
  gsap.timeline({
    onComplete: done
  })
    .to(el, {
      y: '100%'
    })
}
